// extracted by mini-css-extract-plugin
module.exports = {"title":"WelcomePage_title__KH3Cm","paddingContainer":"WelcomePage_paddingContainer__3tNLc","outerContainer":"WelcomePage_outerContainer__33EEq"};